<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <SharePriceBar/>
    <PageHeaderModal link-href="/" bgTint>
      <TextHeading variant="subtitle" color="secondary">Presentations</TextHeading>
      <TextHeading variant="lg" block>Interim Results Announcement 2018/19</TextHeading>
    </PageHeaderModal>
    <PageGrid modal>
      <PageMain>
        <PageSection halfTint>
          <GridRow cols="2">
            <GridCol>
              <figure class="video__image-ratio">
                <img :src="getImage01" alt="Alt description for the image">
              </figure>
            </GridCol>
            <GridCol>
              <figure class="video__image-ratio video__details">
                <img :src="getImage02" alt="Alt description for the image">
              </figure>
            </GridCol>
          </GridRow>
          <VideoControl/>
        </PageSection>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>
<script>
import TheFooter from '../components/TheFooter.vue'
import VideoControl from '../components/VideoControl.vue'
import GridCol from '../elements/GridCol.vue'
import GridRow from '../elements/GridRow.vue'
import PageSection from '../elements/PageSection.vue'
import PageMain from '../elements/PageMain.vue'
import PageGrid from '../elements/PageGrid.vue'
import TextHeading from '../elements/TextHeading.vue'
import PageHeaderModal from '../components/PageHeaderModal.vue'
import SharePriceBar from '../components/SharePriceBar.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
export default {
  name: 'PresentationsVideo',
  components: {
    TheHeader,
    BreadcrumbBar,
    SharePriceBar,
    PageHeaderModal,
    TextHeading,
    PageGrid,
    PageMain,
    PageSection,
    GridRow,
    GridCol,
    VideoControl,
    TheFooter
  },
  methods: {
    handleClick(url) {
      window.location.href = url
    }
  },
  props: {
    image01: {
      type: String,
      default: 'video-screen-grab.png'
    },
    image02: {
      type: String,
      default: 'video-title.png'
    }
  },
  computed: {
    getImage01() {
      return require('@/assets/images/' + this.image01)
    },
    getImage02() {
      return require('@/assets/images/' + this.image02)
    }
  }
}
</script>
<style lang="postcss">
.video__image-ratio {
  @apply aspect-ratio-16/9 w-full bg-body-dark relative overflow-hidden;
}
.video__image-ratio > img {
  @apply block absolute inset-y-0 inset-x-0 w-full h-full;
  object-fit: cover;
}
.video__details {
  @apply hidden;
}
@screen md {
  .video__details {
    @apply block shadow-md;
  }
}
</style>